import { isObjectEmptyNull, formatValue } from "../../../utils/basic";

function processDataQcReport(data) {
    const mainStatsData = {};
    const additionalStats = {};
    if (isObjectEmptyNull(data)) {
        return {
            mainStatsData,
            additionalStats
        };
    }
    // Extract " Main stats & Additional Stats"
    const addStats = data?.find(item => item?.[0] === "Additional Stats")?.[1];
    const mainStats = data?.find(item => item?.[0] === "Main Stats")?.[1];

    if (!mainStats) {
        console.log("No Main Stats Found : API Returning Older data format");
        return {
            mainStatsData,
            additionalStats
        };
    }

    // API new format mathching the UI screens of site 6000 

    const transformedRestData = mainStats ? mainStats?.flatMap((item) => {
        // Access the nested Array ( skip the heading Main stats , its a nested array)
        const { Statistic, Specification, pass } = item;
        const ObservedValue = item['Observed Value'];
        const passfailValue = pass === false ? 'Fail' : pass === true ? 'Pass' : '';
        return { Statistic, Specification, ObservedValue, passfailValue };

    }) : {};

    // this was the old format

    // const transformedRestData = restData.map(item => {
    //     // Check if the second element is an object and look for nested structures
    //     if (typeof item[1] === 'object' && !Array.isArray(item[1]) && item[1] !== null) {
    //         // Look for a nested structure like 'Average'
    //         const nestedKeys = Object.keys(item[1]);
    //         for (let key of nestedKeys) {
    //             if (typeof item[1][key] === 'object') {
    //                 // If a nested structure is found, use its properties
    //                 return {
    //                     statistic: `${item[0]}.${key}`,
    //                     specification: item[1][key].Threshold || '',
    //                     observedValue: item[1][key].Value,
    //                     pass: item[1][key].pass === false ? 'Fail' : item[1][key].pass === true ? 'Pass' : ''
    //                 };
    //             }
    //         }
    //     }

    //     // Fallback for non-nested data
    //     return {
    //         statistic: item[0],
    //         specification: item[1].Threshold || '',
    //         observedValue: item[1].Value || item[1],
    //         pass: item[1].pass === false ? 'Fail' : item[1].pass === true ? 'Pass' : ''
    //     };
    // });



    const transformedAdditionalStats = Object.entries(addStats).reduce((acc, [key, value]) => {
        acc.push({
            Statistic: key,
            Specification: '',
            ObservedValue: formatValue(value.Value) || '',
        });
        return acc;
    }, []);


    return { mainStatsData: transformedRestData, additionalStats: transformedAdditionalStats };

}

export default processDataQcReport



